import { ItemsPerPage } from '@billy/design-system'

import { useFetchSalesDocuments } from './useFetchSalesDocuments'

interface UseHasQuotesProps {
  customerId?: string
  enabled?: boolean
}

export const useHasQuotes = ({ customerId, enabled }: UseHasQuotesProps) => {
  const {
    documents: quotes,
    isFetching,
    isSuccess,
  } = useFetchSalesDocuments({
    ...(customerId ? { customerId } : {}),
    documentsListType: 'quotes',
    isEnabled: enabled ?? true,
    page: 1,
    pageSize: 1 as ItemsPerPage,
  })

  const hasQuotes = isSuccess && quotes.length > 0

  return { isFetching, hasQuotes }
}
